import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal } from "../../../../ui/Modal/Modal";
import { IMAGE, FILE, VIDEO } from "../LiveChatInput/UploadIcons/enum";
import { defaultThemes } from "hoc/AppTemplateWrapper/enum";

import "./ModalPreview.scss";
import ImageView from "components/common/ImageView/ImageView";
import API from "lib/api";
import apiRoutes from "lib/api/apiRoutes";

const { DARK_MODE_DEFAULT } = defaultThemes;

const ModalPreview = ({
    showModal,
    toggleModal,
    preview,
    file, // New prop for direct file object
    previewType,
    fileName,
}) => {
    
    const { defaultTheme } = useSelector((state) => state?.chat?.chatSettings);
    const [fileUrl, setFileUrl] = useState("");
    const [fileBlob, setFileBlob] = useState(null);
    const [fileType, setFileType] = useState(previewType);

    useEffect(() => {
        const processFileInput = async () => {
            try {
                let blob;
                let blobUrl;

                if (file) {
                    // Handle direct file input
                    blob = file;
                    blobUrl = URL.createObjectURL(blob);
                } else if (preview) {
                    // Handle file key
                    
                    const url = apiRoutes.getFileLink;
                    const res = await API.get(url, {
                        params: {
                            fileKey: preview,
                        },
                    });
                    
                    const presignedUrl = res.data?.data;
                    if (!presignedUrl) {
                        return;
                    }

                    const fileResponse = await fetch(presignedUrl);
                    blob = await fileResponse.blob();
                    blobUrl = URL.createObjectURL(blob);
                }

                if (blob && blobUrl) {
                 
                    setFileUrl(blobUrl);
                    setFileBlob(blob);

                    // Determine file type from blob if not already set
                    if (!previewType) {
                        const mimeType = blob.type;
                        
                        let detectedType;
                        if (mimeType.startsWith('image/')) {
                            detectedType = IMAGE;
                        } else if (mimeType.startsWith('video/')) {
                            detectedType = VIDEO;
                        } else {
                            detectedType = FILE;
                        }
                        
                        setFileType(detectedType);
                    }
                }
            } catch (error) {
               
            }
        };

        if (file || preview) {
            processFileInput();
        }

        // Cleanup function to revoke object URL
        return () => {
            if (fileUrl) {
                URL.revokeObjectURL(fileUrl);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [file, preview, previewType]);

    const renderBasedOnPreviewType = () => {
        if (!fileUrl) {
            return null;
        }

        const currentType = fileType || previewType;

        switch (currentType) {
            case IMAGE:
                return (
                    <ImageView
                        src={fileUrl}
                        alt='preview'
                        className='preview__media'
                        isModalPreview={true}
                    />
                );
            case FILE:
                return (
                    <embed 
                        key={fileBlob}
                        width="100%"
                        height="100%"
                        src={fileUrl}
                        type={fileBlob?.type}
                    />
                );
            case VIDEO:
                return (
                    <video className='preview__media' controls>
                        <source src={fileUrl} type={fileBlob?.type} />
                    </video>
                );
            default:
                return (
                    <ImageView
                        src={fileUrl}
                        alt='preview'
                        className='preview__media'
                    />
                );
        }
    };

    const isDarkModeTheme = defaultTheme === DARK_MODE_DEFAULT;
    return (
        <Modal
            show={showModal}
            close={toggleModal}
            fullscreen={true}
            contentClassName={`${
                isDarkModeTheme ? "dark__mode__modal__backdrop" : ""
            }`}>
            <div className='modal__preview--container'>
                {renderBasedOnPreviewType()}
            </div>
        </Modal>
    );
};

export default ModalPreview;
